/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Options_ModalInputs */



/**
* | output |
* | --- |
* | "Close options modal" |
*
* @param {Close_Options_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_options_modal = /** @type {((inputs?: Close_Options_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Options_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre des options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen schließen Modal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra delle opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно с параметрами")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar opciones modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭选项模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプションモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्प बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("modal de fechar opções")
	return /** @type {LocalizedString} */ ("Close options modal")
});